<script>
import ApiModeVuetable from '@src/components/ApiModeVuetable'
import QuestionnaireAnswersService from '@src/services/QuestionnaireAnswersService.js'
import Layout from '@layouts/main'
import pagination from '@src/mixins/pagination'
import swalFeedback from '@src/mixins/swalFeedback'
import filterVuetable from '@src/mixins/filterVuetable'
import vuetableFormatters from '@src/mixins/vuetableFormatters'
import PageHeader from '@components/PageHeader'
import Breadcrumb from '@/src/components/Breadcrumb.vue'
import ImportButton from '@/src/components/ImportButton.vue'
import ExportButton from '@/src/components/ExportButton.vue'
import FilterLabelButton from '@/src/components/FilterLabelButton.vue'
import importModal from '@views/questionnaireAnswers/importJobModal'
import questionnaireAnswersFields from '@src/fields/questionnaireAnswersFields'
import questionnaireAnswersModal from '@src/router/views/questionnaireAnswers/questionnaireAnswersModal'
import questionnaireAnswersFilterModal from '@src/router/views/questionnaireAnswers/questionnaireAnswersFilterModal'

const i18nCommon = 'COMMON'
const i18nKey = 'QUESTIONNAIRE_ANSWERS'

export default {
    components: {
        ApiModeVuetable,
        Layout,
        Breadcrumb,
        PageHeader,
        ExportButton,
        ImportButton,
        FilterLabelButton,
        questionnaireAnswersModal,
        questionnaireAnswersFilterModal,
        importModal
    },
    mixins: [
        swalFeedback,
        pagination,
        vuetableFormatters,
        filterVuetable,
        questionnaireAnswersFields
    ],
    data() {
        return {
            sortOrder: [
                {
                    field: 'updated_at',
                    direction: 'desc',
                },
            ],
            i18nCommon,
            i18nKey,
            data: [],
            perPage: 10,
            css: {},
            additionalParameters: {
                with: [
                    'businessUnit',
                    'pointOfSale',
                    'questionnaire',
                    'answers',
                    'user',
                    'product',
                    'productCategory',
                    'brand',
                ],
            },
            filtered: false,
            filters: {
                questionnaire: [],
                startedAtDateTime: {},
                endedAtDateTime: {},
                business_unit: [],
                point_of_sale: [],
                users: [],
                flags: [],
                regionals: [],
                chains: [],
                statesAndCities: [],
                roles: [],
                teams: [],
                brands: [],
            },
            questionnaireAnswer: {
                id: 0,
                name: '',
            },
        }
    },
    computed: {
        items() {
            return [
                {
                    text: 'Home',
                    href: '/',
                },
                {
                    text: this.getI18nModified({
                        prefix: i18nCommon,
                        suffix: 'report',
                        modifier: 2,
                    }),
                    active: true,
                },
                {
                    text: this.getI18nModified({
                        prefix: i18nKey,
                        suffix: 'TITLES.questionnaire_answer',
                        modifier: 2,
                    }),
                    active: true,
                },
            ]
        },
        i18nQuestionnaireAnswer() {
            return this.getI18nModified({
                prefix: i18nKey,
                suffix: 'TITLES.questionnaire_answer',
                modifier: 2,
            })
        },
        questionnaireRefs() {
            return this.$refs;
        }
    },
    methods: {
        fetch(url, params) {
            if (this.filtered) {
                return QuestionnaireAnswersService.fetchVuetable(url, params)
            }
            return new Promise((resolve, reject) => {
                resolve({});
            })
        },

        createAdditionalParameters() {
            return this.formatParameters({
                with: [
                    'businessUnit',
                    'pointOfSale',
                    'questionnaire',
                    'answers',
                    'user',
                    'product',
                    'productCategory',
                    'brand',
                ],
                city_id: this.filters.statesAndCities.filter((id) => typeof id === 'number'),
                states: this.filters.statesAndCities.filter((id) => typeof id === 'string'),
                chain_id: this.filters.chains.map((chain) => chain.id),
                regional_id: this.filters.regionals.map((regional) => regional.id),
                flag_id: this.filters.flags.map((flags) => flags.id),
                user_id: this.filters.users.map((user) => user.id),
                business_unit_id: this.filters.business_unit.map((unit) => unit.id),
                questionnaire_id: this.filters.questionnaire.map((questionnaire) => questionnaire.id),
                point_of_sale_id: this.filters.point_of_sale.map((pos) => pos.id),
                started_at_date_time: this.formatFilterDate(this.filters.startedAtDateTime),
                ended_at_date_time: this.formatFilterDate(this.filters.endedAtDateTime),
                role_id: this.filters.roles.map((role) => role.id),
                team_id: this.filters.teams.map((team) => team.id),
                brand_id: this.filters.brands.map((brand) => brand.id),
            })
        },

        filter(appliedFilters) {
            this.filtered = true;
            this.filters = appliedFilters;
            this.additionalParameters = this.createAdditionalParameters()
            this.refreshTable()
        },

        showFilterModal() {
            this.$nextTick(() => this.$refs.questionnaireAnswersFilterModal.showModal(this.filters))
        },

        openAnswers(data) {
            this.questionnaireAnswer.id = data.id
            this.questionnaireAnswer.name = data.questionnaire.name
            this.$nextTick(() => this.$refs.questionnaireAnswersModal.showModal())
        },

        refreshTable() {
            this.$nextTick(() => {
                this.$refs.vuetable.refresh()
            })
        },

        showImportModal() {
            this.$nextTick(() => this.$refs.importModal.showModal())
        },

    },
}
</script>

<template>
    <Layout>
        <div class="col-12">
            <Breadcrumb :items="items" />
            <div class="row mt-3">
                <div class="col-sm-6 mb-3 form-inline"></div>
                <div class="col-sm-6 mb-3">
                    <div class="text-sm-right">
                        <filter-label-button @onClick="showFilterModal" />
                        <import-button
                            v-if="$can('CREATE', 'IMPORTJOB')"
                            @onClick="showImportModal"
                        />
                        <export-button
                            v-if="$can('CREATE', 'EXPORTJOB')"
                            ref="exportButton"
                            type="questionnaire_answer"
                            :create-parameters="createAdditionalParameters"
                            :vuetable-ref="questionnaireRefs"
                        />
                    </div>
                </div>
            </div>
            <div class="card card-pdv">
                <PageHeader :title="i18nQuestionnaireAnswer"/>
                <div class="card-body">
                    <api-mode-vuetable
                        ref="vuetable"
                        :fetch-data="fetch"
                        :fields="questionnaireAnswersFields"
                        :per-page="perPage"
                        :display-selection-records-per-page="true"
                        :additional-parameters="additionalParameters"
                        :sort-order="sortOrder">
                        <template slot="answers" slot-scope="props">
                            <div v-if="$can('READ', 'ANSWER')" class="text-center">
                                <b-link
                                    id="answers-modal"
                                    href="#"
                                    class="action-icon"
                                    @click="openAnswers(props.rowData)"
                                >
                                    <i class="fe-file" />
                                </b-link>
                            </div>
                        </template>
                    </api-mode-vuetable>
                </div>
            </div>
        </div>
        <questionnaire-answers-modal
            ref="questionnaireAnswersModal"
            :questionnaire-answer="questionnaireAnswer"
        />
        <questionnaire-answers-filter-modal
            ref="questionnaireAnswersFilterModal"
            :handle-submit="filter"
        />
        <import-modal
            ref="importModal"
            :csv-type="'questionnaire_answers'"
            :title="getI18nModified({
                prefix: i18nKey,
                suffix: 'TITLES.questionnaire_answer',
                modifier: 2,
            })"
        />
    </Layout>
</template>
